
App.controller('CoBrandedSignupCtrl', ['$rootScope', '$scope', '$http', 'ngDialog', '$timeout', '$localStorage',
    '$sessionStorage', '$state', 'Api', 'toastr', 'authApi', '$stateParams', '$loading', 'mixPanelApi', 
     '$location', 'organizationService', 'ProfessionalService', 'UsersClientService', 'sessionService',
    function ($rootScope, $scope, $http, ngDialog, $timeout, $localStorage, $sessionStorage,
              $state, Api, toastr, authApi, $stateParams, $loading, mixPanelApi,
              $location, organizationService, ProfessionalService, UsersClientService, sessionService) {
            $scope.user = {};
            $scope.pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;
            
            this.loadOrganization = async function (key){
                const organization = await organizationService.get(key);
                $scope.organizationName = _.get(organization, 'name');
                $scope.organizationLogo = _.get(organization, 'facility.logoURL');
                $scope.organizationId = _.get(organization, '_id');
                $scope[`organizationNameisDisabled`] = !!$scope.organizationName;
            }
            this.$onInit = async function () {
                console.log("CoBranded Signup Controller");
                $scope.coBrandedKEY = $stateParams.coBrandedKEY;
                $timeout(() => $loading.start('prnSignUp'));

                try {
                    await this.loadOrganization($stateParams.coBrandedKEY);
                    $loading.finish('prnSignUp');
                    $scope.$apply();
                } catch (e) {
                    toastr.error(e.message);
                }
            }

            // =============to submit form=============
            $scope.submit = async function (valid) {
                if(!valid){ return; }

                const organization_id = $scope.organizationId;
                const { firstName, lastName, email, password, phoneNumber } = $scope.user;
                const payload = {
                    item: {
                        firstName,
                        lastName,
                        email,
                        phoneNumber: phoneNumber ? phoneNumber.replace(/\-/g, '') : undefined,
                        profession: 'Nurse',
                    },
                    password
                };

                if (organization_id) {
                    payload.organizationId = organization_id;
                }

                try {
                    $loading.start('prnSignUp');
                    await ProfessionalService.add(payload);
                    $localStorage['coBrandedKEY'] = $stateParams.coBrandedKEY;
                    $scope.signup_message = 'Your email address has been registered. A verification email has been sent to your email account. Please click on the link to verify your address and continue to complete your application.';
                    $timeout(function () {
                        $scope.dialogId = ngDialog.open({
                            template: 'register-popup',
                            className: 'ngdialog-theme-default register-popup',
                            closeByNavigation: true,
                            showClose: false,
                            scope: $scope
                        });
                    }, 100);
                    $loading.finish('prnSignUp');
                } catch (e) {
                    $scope.exist_message = e.message;
                    $loading.finish('prnSignUp');
                    $scope.dialogId = ngDialog.open({
                        template: 'email_exists',
                        className: 'ngdialog-theme-default register-popup',
                        closeByNavigation: true,
                        showClose: false,
                        scope: $scope
                    });
                    $scope.dialogHandler = () => {
                        ngDialog.close($scope.dialogId);
                        if (e.name && !e.name.includes('AddAffiliationRequiredError')) {
                            $state.go('coBrandedLogin', { 'coBrandedKEY': $stateParams.coBrandedKEY });
                        }
                    }
                }
            }

            $scope.resendLink = async function (e) {
                e.preventDefault();
                try {
                    await UsersClientService.resendVerification({ email: $scope.user.email, organizationId: $scope.organizationId });
                    ngDialog.close($scope.dialogId);
                    toastr.success('A verification link has been sent to your email address. Please check your email address.');
                }catch (e){
                    toastr.error(e.message);
                }
            }
            
            /* close Dialogbox function */
            $scope.closeBanner = function () {
                $scope.bannerClose = true;
            }

            $scope.closePopup = function () {
                ngDialog.closeAll();
                $state.go('coBrandedLogin',{'coBrandedKEY':$scope.coBrandedKEY});
            }
    }]);